import React, { useContext } from 'react'

import SearchBar from '@/components/SearchBar'

import { StudentContext } from '@/contexts/Student'

export default function StudentSearchBar() {
  const { setSearchTerm, searchTerm } = useContext(StudentContext)

  return (
    <SearchBar
      onSubmit={setSearchTerm}
      searchTerm={searchTerm}
      placeholder="Search"
    />
  )
}
